import { Box, Card, Image, Text } from 'grommet';
import React from 'react'
import en from '../../../images/en.png';
import fr from '../../../images/fr.png';

const ResLanguageSelector = ({language, onLangChange}) => {

    return (
        <Box direction='row' justify='center' align='center' >
            <Card round={{ corner: 'left' }} direction='row' justify='between' align='center'
                style={{paddingLeft: 30, paddingRight: 15, paddingTop: 7, paddingBottom: 7, backgroundColor: language === 'en' ? '#D6D6D6' : '#fff' }}
                onClick={() => onLangChange('en')}
            >
                <Image src={en} /> <Box style={{ paddingLeft: 15 }}><Text size='small'>English</Text></Box>
            </Card>
            <Card round={{ corner: 'right' }} direction='row' justify='between' align='center'
                style={{ paddingLeft: 15, paddingRight: 30, paddingTop: 7, paddingBottom: 7, backgroundColor: language === 'fr' ? '#D6D6D6' : '#fff' }}
                onClick={() => onLangChange('fr')}
            >
                <Image src={fr} /> <Box style={{ paddingLeft: 15 }}><Text size='small'>Français</Text></Box>
            </Card>
        </Box>
    )
}

export default ResLanguageSelector
